import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { TrqkLogo, IconX } from '@trqk/components';

import './about-trqk.css';
import { ReleaseNotes } from './components';
import { PUBLIC_VERSION } from '../../../constants';

/**
 * Displays some information about the app, including the current version number and release notes.
 * @param {ModalContentProps<{}>} props
 */
export const AboutTrqk = ({
    remove,
}: ModalContentProps<Record<string, never>>): JSX.Element => {
    const history = useHistory();

    useEffect(() => {
        const unlisten = history.listen((location, action) => {
            if (action === 'PUSH') {
                remove({
                    success: true,
                    canceled: false,
                });
            }
        });

        return () => {
            unlisten();
        };
    }, []);

    return (
        <div className="rounded-lg bg-white" style={{ width: 800 }}>
            <div className="border-l-4 border-primary-500 rounded-tl-lg pt-4 px-10 pb-4">
                <div className="flex justify-end">
                    <button
                        className="mt-4 mb-2 respond-to-mouse"
                        type="button"
                        onClick={(): void => {
                            remove({
                                canceled: true,
                                success: false,
                            });
                        }}
                    >
                        <IconX width={20} fillColor="tertiary-400" />
                    </button>
                </div>
                <div className="flex flex-col items-center">
                    <TrqkLogo width={150} />
                    <div className="mt-2 text-tertiary-400 tracking-widest">
                        Version {PUBLIC_VERSION}
                    </div>
                </div>
            </div>
            <div
                className="overflow-y-auto mt-2 mb-8 mx-8"
                style={{ maxHeight: 600 }}
            >
                <div className="release-notes mx-4">
                    <ReleaseNotes />
                </div>
            </div>
        </div>
    );
};
